module.exports = __webpack_public_path__ + "static/media/sliders-h.e02a94e0.svg";